/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { Field, Form, Formik, FieldArray } from "formik";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {DayPicker} from 'react-day-picker';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext, GlobalLoaderContext } from 'store/context';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { number } from 'prop-types';
import { set } from 'numeral';
import { stubTrue } from 'lodash';

import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import CheckBox from 'components/Form/CheckBox';
import { Row, Col } from 'components/Grid';
import { Label, SelectField } from "components/Form";
import InputField from 'components/Form/InputField';
import Colors from 'constants/Colors';
import DialogComponent from "components/Dialog";
import { stringToNumber } from 'utils/src/convertToString';
import { convertToCurrency } from 'utils/src/convertToCurrency';
import { ButtonContent, Text, TableHeader, DialogCancel, DialogConfirm, DialogSelect, Line, TableContainer, Scrollbox, CalendarContainer } from './styles';
import StepNavigation from 'components/StepNavigation/index';

export default function ScheduleInitialExport(props) {

  const [total, setTotal] = useState(0);
  const [summary, setSummary] = useState([]);
  const [sortList, setSortList] = useState([]);
  const [metadata, setMetaData] = useState({});
  const [data, setData] = useState([{}]);
  const [testData, setTestData] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [showData, setShowData] = useState(false);
  const alreadyApproved = false;
  const [filter, setFilter] = useState(
    {
      key: null,
      direction: null,
    }
  );
  const coluns = [
    {
      title: "Insurer",
      value: "nmInsurer"
    },
    {
      title: "Premium Rate",
      value: "premiumRate"
    },
    {
      title: "Line Size",
      value: "lineSinze"
    },
    {
      title: "% Line Size",
      value: "percLineSize"
    },
    /*  {
       title: "Premium",
       value: "premium"
     }, */
    {
      title: "Brokerage",
      value: "brokerage"
    },
  ];

  const formik = useRef(Formik);
  const history = useHistory();
  const { idOperation } = props.match.params;
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const operationContext = useContext(GlobalOperationContext);
  const authContext = useContext(GlobalAuthContext);

  //////////// Lost Dialog ///////////////// 

  //const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjExMDAsInVzZXJuYW1lIjoicG9jX3RleGVsQGZpdGluc3VyLmNvbS5iciIsInBlcnNvbmlkIjoxMDE3MDMsImZpcnN0TmFtZSI6IlRFWEVMIiwibGFzdE5hbWUiOiJGSU5BTkNFIExJTUlURUQiLCJpZFBlcnNvblJvb3QiOjEwMTcwMywidXNlcmFkbWluIjpmYWxzZSwiZW51bVByb2ZpbGUiOjAsImV4cCI6MTU5ODk5MDA4MywiaWF0IjoxNTk4NTU4MDgzfQ.dEGXF8-urvX_Fx5FPT8HOUfkq96RJD5zOoU3LkNmUNU"
  // fitinsur.setAuthToken(authContext.token);
  /* fitinsur.setAuthToken(token); */

  const [lostDeal, setLostDeal] = useState({
    formated: [],
    array: [],

  });

  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
  });


  async function getGridItems() {
    fitinsur.setAuthToken(authContext.token);
    await fitinsur.requestInsurerTotals(idOperation)
      .then(x => x.json()).then(response => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        console.log(response);
        let d = response.ret_value.insurers.map((item) => {
          let insurer = {
            idPersonInsurer: item.idPersonInsurer,
            nmInsurer: item.insurerFirstName,
            maxLineSize: item.nbiRequestInsurerResponse.maxLineSize,
            premiumRate: item.premiumRate || item.nbiRequestInsurerResponse.premiumRate,
            lineSize: item.lineSize || item.nbiRequestInsurerResponse.lineSize,
            percLineSize: item.percLineSize || item.nbiRequestInsurerResponse.percLineSize,
            brokerage: item.brokerage || item.nbiRequestInsurerResponse.brokerage,
            premium: item.nbiRequestInsurerResponse.premium || '-'
          }
          return insurer;
        })
        /*   setMaxLimit(res.ret_value.maxLimitLiability) */
        setData(d);
        console.log(d);


      }).catch(e => console.log(e));





    /*  .then((response) => {return response.json()})
     .then((output) => output.ret_value.insurers)
     .then((retrieve) => {console.log(retrieve); setData(retrieve); formik.current.setValues({ list: [...retrieve]}
       )} */
  };

  const requestLostDealList = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestLostDealList()
      .then((response) => {
        return response.json();
      })
      .then((data) => {

        if (data.ret_value) {
          const lista = [];
          for (let index = 0; index < data.ret_value.length; index++) {
            lista.push({ label: data.ret_value[index].ANSWER_OPTION_DESCRIPTION, value: data.ret_value[index].ID_ANSWER_OPTION })

          }
          setLostDeal({ formated: lista, array: data.ret_value });

        } else {
          mc.error("fitGetLostReason - UNEXPECTED RETURNED DATA => " + JSON.stringify(data));
          setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
        }


      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${requestLostDealList.name}\n` + error);
        console.error('fitGetLostReason - Error:', error);
        setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
      });
  }

  // requestLostDealList();

  const HandleLostSubmit = (selectedID) => {
    if (!selectedID) {
      mc.error("Please, select at least one option.");
      return;
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.updateQuoteEdit(props.match.params.idOperation, selectedID).then(x => x.json()).then(res => {
      console.log(res)
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      history.push('/list');
      /* setDialog({ visible: false, title: null, icon: null, args: null });
      lostReasonsRef.current?.setFieldValue('reasons', ''); */
    })


  }

  ///////////////////////////

  const rightIconClick = () => {
    setShowData(!showData);
  }

  function handleSortList(key) {

    let direction = 'asc';
    if (filter.key === key && filter.direction === 'asc') {
      direction = 'desc';
    }
    setFilter({ key: key, direction: direction });

    console.log("Lista Ordenada-> ", sortList);
    console.log("Ordem key-> ", filter.direction);
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  const getClassNamesFor = (name) => {
    if (!filter) {
      return;
    }
    return filter.key === name ? filter.direction : undefined;
  };

  function handleDialog() {
    setDialog({
      visible: true,
      title: "LOST DEAL",
      icon: "TimesCircle",
      args: null,
    })
    requestLostDealList();
  }

  function handleSelect(e) {

    //procura se o item ja existe no array
    const alreadySelected = selectedItems.findIndex((item) => item.insurer === e.insurer);
    //se ele não encontrar retornará -1
    if (alreadySelected >= 0) {
      //filtra o array removendo o id
      const filteredItems = selectedItems.filter((item) => item.insurer !== e.insurer);
      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([...selectedItems, e]);
    }
  };

  function handleBack() {
    history.goBack();
  };

  function _arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  const handleNbi = async (values) => {

    console.log(values);
    let v = { ...values };
    delete v["insurers"];
    let body = {
      idOperation: parseInt(props.match.params.idOperation),
      ...v
    }
    /* console.log("submit", body); */
    let name;
    fitinsur.setAuthToken(authContext.token);
    fitinsur.generateExceXLS(body)
      .then(x => { if (x.status == 200) { name = x.headers.get('Content-Disposition'); return x.blob() } }).then(res => {
        /* var blob = new Blob([res], { type: 'application/vnd.openxmlformats' }); */
        console.log(res);
        const url = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        name = (name.split('='))[1].replace('"', '');
        a.download = name.substring(0, name.length - 1);
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        /* mc.error('your file has downloaded!'); */
        /* var url = URL.createObjectURL(res);
        window.open(url); */

        /*  window.URL.revokeObjectURL(url); */
      })
    /* console.log("handle NBI", values);

    const {startDate, payments, paymentFrequency} = values.values.list;
    let body = {
      startDate, payments, paymentFrequency, idOperation
    };

    console.log(body);
    
    await fitinsur.generateExceXLS(idOperation, body)
    .then(res => { return res.json();
    }).then(response => console.log(response)); */
  };

  function handleWording() {
    history.push(`/broking/send-wording-request/${props.match.params.idOperation}`);
  };

  function updateData(values) {
    setData(values);
  };

  const gatherTotals = (list, params) => {
    if (Array.isArray(list)) {
      if (list.length != 0) {
        const nums = list.map(item => {
          return item[params];
        });
        let b = 0;
        nums.forEach(x => (b = b + Number(x)));
        return b;
        /*  return b.toFixed(2).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","); */
      }
      return '-';
    }
    return '-';

  }

  const gatherTotals2 = (list, params) => {
    if (Array.isArray(list)) {
      if (list.length > 0) {
        const nums = list.map(item => {
          return item[params] || '';
        });
        let b = 0;
        nums.forEach(x => (b = b + Number(x)));
        if (isNaN(b)) {
          return "-"
        } else {
          return convertToCurrency(b);
        }
      }
    }


  }

  const validations = yup.object().shape({
    startDate: yup.string().required('* Required field'),
    payments: yup.string().required('* Required field'),
    paymentFrequency: yup.string().required('* Required field')
  });

  useEffect(() => {
    console.log("Handle NBI: ", metadata);
  }, [handleNbi])

  useEffect(() => {
    if (data) {
      if (formik.current) {
        formik.current?.setFieldValue('insurers', data);
      }
    }
  }, [data]);

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };
    getGridItems();
  }, []);

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.client ? summary.client : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"} >
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
      <BrokingSummary data={summary} />
      <ContentCard title="MARKET COMPOSITION" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <DialogComponent
          icon={dialog.icon}
          title={dialog.title}
          
          show={dialog.visible}
          setDialog={setDialog}>

          <Formik initialValues={{ reasons: '' }} onSubmit={(e) => { HandleLostSubmit(e.reasons); }}>
            <Form>
              <DialogSelect>
                <Field
                  name="reasons"
                  placeholder="Select the reason the deal was lost"
                  component={SelectField}
                  options={lostDeal.formated}
                />

              </DialogSelect>
              <DialogCancel onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDialog({ visible: false, title: null, icon: null, args: null }); }}>Cancel</DialogCancel>
              <DialogConfirm type="submit">Confirm</DialogConfirm>
            </Form>
          </Formik>
        </DialogComponent>
        <>
          <Row style={{ display: "flex", margin: "5px 10px", paddingBottom: "15px", justifyContent: "center", alignItems: "center" }}>
            <Col>
              <Text secundary>MAIN CONTRACT - </Text>
            </Col>
          </Row>
        </>
        <Row style={{ marginLeft: "0px", marginRight: "0px", justifyContent: "center", alignItems: "center" }}>
          {coluns ? coluns.map((colun, index) =>
            <Col key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

              <Text onClick={() => handleSortList(colun.value)} style={{ margin: "0 auto", textTransform: "uppercase" }}>
                {colun.title}
              </Text>

              {filter.key === colun.value && filter.direction === "asc" ?
                <FontAwesomeIcon icon={faChevronUp} color={Colors.GRAY[6]} size="1x" /> : <FontAwesomeIcon icon={faChevronDown} color={Colors.GRAY[6]} size="1x" />}
            </Col>) : ""}

        </Row>

        <Formik
          initialValues={{ insurers: [], startDate: '', payments: '', paymentFrequency: '' }}
          innerRef={formik}
          onSubmit={handleNbi}
          validationSchema={validations}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <FieldArray name="insurers" render={(arrayHelpers) => (
                <>
                  <Scrollbox>


                    {values.insurers && values.insurers.length >= 1 ? values.insurers.map((item, index) => (
                      <>
                        <Row key={index} style={{ display: "flex", margin: "5px 10px", justifyContent: "center", alignItems: "center" }}>

                          <Col style={{ display: "flex", fontWeight: "bold", color: 'gray' }}>
                            <Text style={{ whiteSpace: "nowrap" }}>{item?.nmInsurer}</Text>
                          </Col>
                          <Col style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>{convertToCurrency(item?.premiumRate)}%</Text>
                          </Col>
                          <Col style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold" }}>
                            <Text style={{ whiteSpace: "nowrap" }}> {convertToCurrency(item?.lineSize)}</Text>
                          </Col>
                          <Col style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>{convertToCurrency(item?.percLineSize)}%</Text>
                          </Col>
                          {/* <Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>$ {(item?.premium ? convertToCurrency(item?.premium) : "-")}</Text>
                          </Col> */}
                          <Col style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>{convertToCurrency(item?.brokerage)} %</Text>
                          </Col>

                        </Row>
                        <Line />
                      </>
                    )) : ''
                    }

                    {
                      <>
                        <Row style={{ display: "flex", margin: "5px 10px", justifyContent: "center", alignItems: "center" }}>
                          <Col>
                            <Text secundary>TOTAL</Text>
                          </Col>
                          <Col style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                            <Text style={{ whiteSpace: "nowrap" }}> {gatherTotals2(values.insurers || [], "premiumRate")} % </Text>
                          </Col>
                          <Col style={{ display: "flex", textAlign: "center", justifyContent: "center", fontWeight: "bold", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>{gatherTotals(values.insurers, "lineSize")}  </Text>
                          </Col>
                          <Col style={{ textAlign: "center", marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                            <Text style={{ whiteSpace: "nowrap" }}> {gatherTotals(values.insurers, "percLineSize")} % </Text>
                          </Col>
                          {/* <Col style={{ textAlign: "center", marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>$ {gatherTotals2(values.insurers || [], "premium")}</Text>
                          </Col> */}
                          <Col style={{ textAlign: "center", marginLeft: "0px", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "5px", color: "black" }}>
                            <Text style={{ whiteSpace: "nowrap" }}>{gatherTotals(values.insurers, "brokerage")} %</Text>
                          </Col>
                        </Row>
                        <Line />
                        <Row>
                          <Col md={2} style={{ margin: '5px 0px 0px 15px' }}>
                            <Field
                              name={`startDate`}
                              label='Start Date'
                              value={values.startDate}
                              isRequired
                              component={InputField}
                              rightIcon='calendar'
                              type='text'
                              mask="99/99/9999"
                              rightIconClick={() => { setShowData(!showData) }}
                              onChange={(e) => setFieldValue(`startDate`, e)}

                            >
                            </Field>
                            {
                              showData ? (
                                <CalendarContainer>
                                  <DayPicker
                                    disabledDays={[
                                      {
                                        before: new Date()
                                      }
                                    ]}
                                    fixedWeeks
                                    onDayClick={(t) => { setFieldValue(`startDate`, new Date(t) ? new Date(t) <= new Date() ? new Date().toLocaleDateString('en-GB') : new Date(t).toLocaleDateString('en-GB') : null); setShowData(false); }} >
                                  </DayPicker>
                                </CalendarContainer>) : null
                            }
                          </Col>

                          <Col md={2} style={{ margin: '5px 0px 0px 15px' }}>
                            <Field name={`payments`} value={values.payments} onChange={e => setFieldValue(`payments`, e)} onBlur={() => updateData(values.insurers)} label='Payments' isRequired component={InputField} type='number'></Field>
                          </Col>

                          <Col md={2} style={{ margin: '5px 0px 0px 15px' }}>
                            <Field name={`paymentFrequency`} value={values.paymentFrequency} label='Payment Frequency' isRequired component={SelectField} onChange={(e) => { console.log(values.insurers); setFieldValue(`paymentFrequency`, e) }} onBlur={() => updateData(values.insurers)}
                              options={[{ label: "Monthly", value: "monthly" }, { label: "Trimestral", value: "trimestral" }, { label: "Quadrimestral", value: "quadrimestral" }, { label: "Semestral", value: "semestral" }, { label: "Yearly", value: "yearly" }]}>
                            </Field>
                          </Col>

                        </Row>
                        <Line />
                      </>
                    }


                  </Scrollbox>
                  <ButtonContainer>
                    <Button onClick={() => { history.goBack() }}>&lt; Back</Button>
                    <ButtonContent>

                      <Button
                        secundary
                        name="Lost"
                        id="btnLost"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog() }}
                      >

                        LOST</Button>

                      <Button
                        onClick={() => { history.push(`/broking/market-selection/${props.match.params.idOperation}`, { idProduct: props.location.state.idProduct }) }}
                        third
                        style={{ marginLeft: "10px" }}
                      >
                        UPDATE NBI
                      </Button>
                      {
                        alreadyApproved ? (
                          <>
                            <Button primary onClick={() => handleWording()} style={{ marginLeft: "10px" }}>WORDING</Button>
                            <Button primary type="submit" style={{ marginLeft: "10px" }}>SCHEDULE</Button>
                          </>) : (

                            <>
                              <Button type="submit" primary style={{ marginLeft: "10px" }}>EXPORT TEMPLATE</Button>
                            </>
                          )
                      }

                    </ButtonContent>
                  </ButtonContainer>
                </>
              )}
              />

            </Form>

          )}
        </Formik>
      </ContentCard>
    </Layout>
  )
}